import React from "react";
import { Box } from "@mui/material";
import "./AnalyticsCards.css";

interface StatusItem {
  label: string;
  icon: React.ReactNode;
  count: number;
  subLabel?: string;
  bgColor: string; // Example: "bg-blue-50"
  textColor: string; // Example: "text-blue-600"
}

interface AnalyticsCardsProps {
  statuses: StatusItem[];
}

export function AnalyticsCards({ statuses }: AnalyticsCardsProps) {
  return (
    <Box className="analytics-container">
      {statuses.map((status, idx) => (
        <Box key={idx} className="analytics-card">
          <Box className={`analytics-icon-wrapper ${status.bgColor}`}>
            <span className={status.textColor}>{status.icon}</span>
          </Box>

          <span className="analytics-title">{status.label}</span>

          <div className="analytics-value">{status.count}</div>
        </Box>
      ))}
    </Box>
  );
}
